module.exports = __webpack_public_path__ + "img/input-plus.4cf44b14.svg";